import React from 'react'
import styles from "./baguette.module.css";

const Baguette = () => {
  return (
    <div className={styles.main}>
      <div className={styles.oval}>
        <div className={styles.botline}></div>
        <div className={styles.midline}></div>
        <div className={styles.topline}></div>
      </div>
    </div>
  )
}

export default Baguette